import { i18n, type Locale } from '@appwin/shared';

export type Translator = (id: i18n.MessageId, params?: Record<string, string | number>) => string;

export function translator(locale: Locale): Translator {
  return (id, params) => i18n.translate(locale, id, params);
}

export const SUPPORTED_LOCALES: Locale[] = ['en', 'ru'];

export function htmlLang(locale: Locale): string {
  return locale === 'ru' ? 'ru' : 'en';
}

/** Open Graph locales use the `language_TERRITORY` form. */
export function ogLocale(locale: Locale): string {
  return locale === 'ru' ? 'ru_RU' : 'en_US';
}
